'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.System.SystemConstants', dependencies).constant('SystemConstants', require('../constants/SystemConstants'));